export default __webpack_public_path__ + "static/media/Cloudxier-IAN-Profile-Developer.bbb3d394.png";